import React from 'react';
import Toast from './Toast';

const ToastContainer = ({ toasts, onRemoveToast }) => {
  return (
    <>
      {toasts.map((toast, index) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          show={toast.show}
          position="top-right"
          onClose={() => onRemoveToast(toast.id)}
          onConfirm={toast.onConfirm}
          onCancel={toast.onCancel}
        />
      ))}
    </>
  );
};

export default ToastContainer;
